import ModalSequence from './ModalSequence';
import { RulesImg1, RulesImg2, RulesImg3, RulesImg4, RulesImg5, RulesImg6 } from './assets';

interface RulesProps {
  onClose: () => void;
}

const Rules: React.FC<RulesProps> = ({ onClose }) => {

    const welcomeModals = [
        {
          title: '',
          imageSrc: RulesImg1,
          content:  <>
                        <p>GM, nice to meet you!</p>
                        <p>This is NOTAPP - a game where you get rewards for... hm, NOT playing? being NOT active? NOT using the app?</p>
                        <p>Absolute madness! Let's see how it works...</p>
                    </>,
          buttonText: 'Let\'s see!',
        },
        {
          title: '',
          imageSrc: RulesImg2,
          content:  <>
                        <p>You farm NOTAPP coins (NAP) every day, <span className="text-red-500">Base Reward = 10 NAP.</span></p>
                        <p>But you can multiply rewards with your <span className="text-red-500">Farm Multiplier (FM):</span></p>
                        <p>FM = x2, daily reward is 20 NAP<br />FM = x3, daily reward is 30 NAP, etc.</p>
                    </>,
          buttonText: 'Cool!',
        },
        {
          title: '',
          imageSrc: RulesImg3,
          content:  <>
                        <p>Farm Multiplier <span className="text-red-500">grows by x1</span> every day you haven't used NOTAPP</p>
                        <p>Missed 1 day, FM = x1, missed 2 days, FM = x2 and so on - <span className="text-red-500">up to x10!</span></p>
                        <p>Do your stuff and save your time - there are NO TAPS, daily check-ins, games and other time drainers.</p>
                    </>,
          buttonText: 'Clear!',
        },
        {
            title: '',
            imageSrc: RulesImg4,
            content:    <>
                            <p>Farm Multiplier has its maximum and cannot exceed <span className="text-red-500">Farm Multiplier Limit (FML)</span> - it is x10 at the start.</p>
                            <p>Farm Multiplayer Limit <span className="text-red-500">can be increased</span> through completing tasks and inviting friends - thus you can multiply your rewards by several times! (available in future, some day...)</p>
                        </>,
            buttonText: 'Fine!',
        },
        {
            title: '',
            imageSrc: RulesImg5,
            content:    <>
                            <p>However, be careful! Every timer you open NOTAPP, your FM <span className="text-red-500">is reset to Base Farm Multiplier (Base FM)</span> (x1 at the start). Oooops...</p>
                            <p>You <span className="text-red-500">collect rewards</span> for the whole time since your last login to the app, though.</p>
                        </>,
            buttonText: 'Go on!',
        },
        {
            title: '',
            imageSrc: RulesImg6,
            content:    <>
                            <p><span className="text-red-500">With FML increasing, your Base FM also increases</span> - e.g. with FML = x15 your base FM = x1.5, not = x1.</p>
                            {/*<p>Check out whitepaper to see more details, follow NOTAPP channel and join the most NOTACTIVE community!</p>*/}
                            <p>Follow <a href="https://t.me/notappgame" target="_blank" className="text-grey-800 underline">NOTAPP channel</a> and join the most <a href="https://t.me/notappgame_chat" target="_blank" className="text-grey-800 underline">NOTACTIVE community</a>!</p>
                        </>,
            buttonText: 'Got it!',
        },
      ];
    
      const handleSequenceComplete = () => {
        onClose();
      };

    return (
        <ModalSequence modalsData={welcomeModals} onComplete={handleSequenceComplete} />
    )
}

export default Rules
